import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AuthenticationService } from './user/authentication.service';
import { AppComponent } from './app.component';
import { LoginComponent } from './user/login/login.component';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PortalComponent } from './portal/portal.component';
import { SignUpPortalComponent  } from './user/sign-up-portal/sign-up-portal.component';
import { SignUpWebResumeComponent } from './user/sign-up-web-resume/sign-up-web-resume.component';
import { ServiceDashboardComponent } from './portal/service-dashboard/service-dashboard.component';
import { ServiceDashboardService } from './portal/service-dashboard/service-dashboard.service';
import { ChangeLogComponent } from './software-services/change-log/change-log.component';
import { ClientService } from './client/client.service';
import { ResumeService } from './resume/resume.service';
import { GoogleKeywordService } from './software-services/search-engine-optimization/keywords/google-keyword.service';
import { AppRoutingModule } from './app-routing.module';
import { LandingPageComponent } from './portal/service-dashboard/landing-page/landing-page.component';
import { SeoDashboardComponent } from './software-services/search-engine-optimization/seo-dashboard/seo-dashboard.component';
import { ThumbnailButtonComponent } from './portal/service-dashboard/thumbnail-button/thumbnail-button.component';
import { SmmDashboardComponent } from './software-services/social-media-marketing/smm-dashboard/smm-dashboard.component';
import { SeoDashboardSettingsComponent } from './software-services/search-engine-optimization/seo-dashboard-settings/seo-dashboard-settings.component';
import { SmmDashboardSettingsComponent } from './software-services/social-media-marketing/smm-dashboard-settings/smm-dashboard-settings.component';
import { ClientInfoPanelComponent } from './portal/service-dashboard/client-info-panel/client-info-panel.component';
import { WebsiteDashboardComponent } from './software-services/website-package/website-dashboard/website-dashboard.component';
import { WebsiteDashboardSettingsComponent } from './software-services/website-package/website-dashboard-settings/website-dashboard-settings.component';
import { ChartComponent } from './widgets/matrix-tools-chart/chart.component';
import { EmployeeDashboardComponent } from './portal/service-dashboard/employee-dashboard/employee-dashboard.component';
import { ToolsDashboardComponent } from './portal/tools-dashboard/tools-dashboard.component';
import { CreateOnlineResumeComponent } from './resume/create-online-resume/create-online-resume.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    PortalComponent,
    SignUpPortalComponent,
    SignUpWebResumeComponent,
    ServiceDashboardComponent,
    ChangeLogComponent,
    LandingPageComponent,
    SeoDashboardComponent,
    ThumbnailButtonComponent,
    SmmDashboardComponent,
    SeoDashboardSettingsComponent,
    SmmDashboardSettingsComponent,
    ClientInfoPanelComponent,
    WebsiteDashboardComponent,
    WebsiteDashboardSettingsComponent,
    ChartComponent,
    EmployeeDashboardComponent,
    ToolsDashboardComponent,
    CreateOnlineResumeComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule
  ],
  providers: [
    AuthenticationService, ClientService, ServiceDashboardService, GoogleKeywordService, ResumeService
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
